import { render, staticRenderFns } from "./IncompatibleVersion.vue?vue&type=template&id=1d18253a&scoped=true"
import script from "./IncompatibleVersion.vue?vue&type=script&lang=js"
export * from "./IncompatibleVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d18253a",
  null
  
)

export default component.exports